<ng-container *transloco="let t">
  <app-page-template>
    <div class="empty-state-wrapper d-flex justify-content-center align-items-center p-4">
      <section class="d-flex justify-content-center align-items-center flex-column">
        <h2 class="pb-3">404</h2>
        <h1 class="pb-3 text-center">{{t('emptyState.title')}}</h1>
        <p class="pb-4 text-center">{{t('emptyState.subTitle')}}</p>
        <div class="text-center">
          <app-button [label]="t('app.common.go.back')"
                      [btnClass]="'btn-primary-red btn-large'" (onClick)="onGoToEventCalendar()"/>
        </div>
      </section>
    </div>
  </app-page-template>
</ng-container>
